import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Lembrete, LembreteListModel, LembretePostModel } from "app/models/lembrete.model";
import { PaginacaoModel, ResultadoPaginado } from "app/models/paginacao.model";
import { RespostaPadrao } from "app/models/resposta-padrao.model";
import { environment } from "environments/environment";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class LembreteService {
    constructor(private httpClient: HttpClient) { }

    adicionar(lembrete: LembretePostModel): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Lembrete/adicionar/`, lembrete)
        );
    }

    atualizar(lembrete: LembretePostModel): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Lembrete/atualizar/`, lembrete)
        );
    }

    concluir(lembreteId: number): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.put<RespostaPadrao>(`${environment.urlApi}/Lembrete/concluir/${lembreteId}`, null)
        );
    }

    remover(lembreteId: number): Promise<RespostaPadrao> {
        return firstValueFrom(
            this.httpClient.delete<RespostaPadrao>(`${environment.urlApi}/Lembrete/remover/${lembreteId}`)
        );
    }

    obter(lembreteId: number): Promise<Lembrete> {
        return firstValueFrom(
            this.httpClient.get<Lembrete>(`${environment.urlApi}/Lembrete/obter/${lembreteId}`)
        );
    }

    obterLista(paginacao: PaginacaoModel, clienteId?: number): Promise<ResultadoPaginado<LembreteListModel>> {
        let params = new HttpParams()
            .set('pagina', paginacao.pagina)
            .set('tamanhoPagina', paginacao.tamanhoPagina)
            .set('ordenarPor', paginacao.ordenarPor)
            .set('descendente', paginacao.descendente);
        if (paginacao.pesquisa) params = params.set('pesquisa', paginacao.pesquisa);
        if (clienteId) params = params.set('clienteId', clienteId);
        return firstValueFrom(
            this.httpClient.get<ResultadoPaginado<LembreteListModel>>(`${environment.urlApi}/Lembrete/obterLista/`, { params })
        );
    }
}
